import { useContext, useEffect, useState } from "react";
import {
  Button,
  Divider,
  Menu,
  MenuItem,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SecurityIcon from "@mui/icons-material/Security";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import LogoutIcon from "@mui/icons-material/Logout";

import config from "../../../../config";
import { HOME_PAGE_ROUTE, MFA_SETTINGS_PAGE_ROUTE } from "../../../constants/routerConstants";
import JwtUtils from "../../../router/JwtUtils";
import { AuthContext } from "../../general/TSAuthProvider";
import { useTSData } from "../../general/TSDataContext";

export const ProfileLogo = ({ isMobile, ...props }) => {
  const { logout, resetMfa } = useContext(AuthContext);
  const { setIsLoading } = useTSData();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openResetDialog, setOpenResetDialog] = useState(false);
  const navigate = useNavigate();

  const [imageSrc, setImageSrc] = useState("/assets/userImg.png");

  // MFA settings is only available for basic (email/password) accounts.
  // Social login users (google, facebook, linkedin, apple, pmpce) are
  // authenticated by a trusted provider — MFA is not applicable.
  const source = localStorage.getItem("source");
  const isBasicUser = source === "basic";

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    setIsLoading(true);
    logout();
    handleClose();
    setIsLoading(false);
    navigate(HOME_PAGE_ROUTE);
  };
/*
  const handleSecuritySettings = () => {
    handleClose();
    navigate(MFA_SETTINGS_PAGE_ROUTE);
  };
  */

  
  const handleOpenResetDialog = () => {
    handleClose();              
    setOpenResetDialog(true);   
  };

  const handleCloseDialog = () => {
    setOpenResetDialog(false);
  };

  const handleConfirmReset = () => {
    resetMfa({
      onSuccess: () => {
        setOpenResetDialog(false);
      },
      onFail: (msg) => {
        setOpenResetDialog(false);
        console.error(msg);
      },
    });
  };

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await fetch(`${config.baseURL}api/user/image`, {
          headers: {
            Authorization: `Bearer ${localStorage.token}`,
          },
        });

        if (!response.ok) throw new Error("Image fetch failed");

        const blob = await response.blob();
        const objectURL = URL.createObjectURL(blob);
        setImageSrc(objectURL);
      } catch {
        setImageSrc("/assets/userImg.png");
      }
    };

    fetchImage();

    return () => {
      if (imageSrc.startsWith("blob:")) URL.revokeObjectURL(imageSrc);
    };
  }, []);

  return (
    <div>
      <Button
        color="primary"
        onClick={handleClick}
        sx={{
          cursor: "pointer",
          zIndex: 10,
          padding: 0,
          fontSize: "12px",
          ml: 5,
          gap: 2,
          mr: isMobile ? 3 : 5,
          ...(!isMobile && { mt: 2 }),
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontFamily: "Montserrat",
            fontSize: isMobile ? "7px" : "12px",
            fontWeight: 500,
            lineHeight: isMobile ? "10px" : "24.8px",
            textAlign: "right",
            textUnderlinePosition: "from-font",
            textDecorationSkipInk: "none",
            color: "#0B0D0A",
          }}
        >
          {JwtUtils.getName() || ""}
        </Typography>

        <img
          src={imageSrc}
          alt="UserLogo"
          style={{
            width: "31px",
            height: "31px",
            borderRadius: "50%",
            color: "#D9D9D9",
          }}
        />
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{ marginTop: "3px" }}
      >
        
   

        {isBasicUser && (
          <MenuItem onClick={handleOpenResetDialog} sx={{ gap: 1 }}>
            <RestartAltIcon sx={{ fontSize: 18, color: "#1B738A" }} />
            <Typography variant="body2">Réinitialiser MFA</Typography>
          </MenuItem>
        )}

        {isBasicUser && <Divider />}

        <MenuItem onClick={handleLogout} sx={{ gap: 1 }}>
          <LogoutIcon sx={{ fontSize: 18, color: "#555" }} />
          <Typography variant="body2">Déconnexion</Typography>
        </MenuItem>
      </Menu>

      {/* Confirmation de réinitialisation MFA */}
      <Dialog open={openResetDialog} onClose={handleCloseDialog}>
        <DialogTitle sx={{ textAlign: "center", fontWeight: "bolder" }}>
          Réinitialisation MFA
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ color: "primary.main" }}>
            Voulez-vous vraiment réinitialiser votre MFA ?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ margin: 2 }}>
          <Button onClick={handleCloseDialog} color="secondary">
            Annuler
          </Button>
          <Button onClick={handleConfirmReset} variant="contained" color="primary">
            Oui
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};